import useTheme from './use-theme'

export function useFont() {
  const { customFonts, fonts } = useTheme()

  return { body: customFonts[fonts.body] } as const
}
